// Core
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import {
  checkLinkForCreatePasswordRequest,
  forgotPasswordRequest,
} from "../../../Redux/Slices/authSlice";

// Styles
import "./styles.scss";

// Utils
import { getDeviceId } from "Services/Utils/commonServices";
import { validateInput } from "Services/Utils/validateInput";
import { notifySuccess } from "Services/Utils/toastNotification";

// Assets
import passwordIcon from "./../../../Assets/Icons/passwordIcon.png";

// Layouts
import AuthLayout from "Layouts/Auth";

// Custom components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import ErrorMessage from "Components/ErrorMessage";

const ResetPassword = () => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initialize useNavigate
  const navigate = useNavigate();

  //To get params
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const slug = queryParams.get("slug");

  //Core useEffect
  useEffect(() => {
    if (slug) {
      dispatch(
        checkLinkForCreatePasswordRequest({
          slug,
          navigate
        })
      );
    }
  }, []);

  const userDetails = JSON.parse(localStorage?.getItem("userDetails"));

  // Form data and validation errors state
  const initialFormData = { password: "", confirmPassword: "" };
  const initialErrors = {};

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Validate form
  const handleValidation = () => {
    const validationErrors = {
      ...validateInput("password", formData.password),
      ...validateInput(
        "confirmPassword",
        formData.confirmPassword,
        formData.password
      ),
    };
    setErrors(validationErrors);
    return validationErrors;
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      dispatch(
        forgotPasswordRequest({
          data: {
            new_password: formData?.password,
            confirm_password: formData?.confirmPassword,
            email: userDetails?.email,
            device_token: getDeviceId(),
          },
          callBack: forgotPasswordRequestCB,
        })
      );
    }
  };

  const forgotPasswordRequestCB = (data) => {
    notifySuccess(
      "Your password has been successfully updated. Now you can explore KG Maintenance Assessment Portal."
    );
    localStorage?.setItem("isLoggedIn", null);
    navigate("/", { replace: true });
    setFormData(initialFormData);
    setErrors(initialErrors);
  };

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit} className="login-root-container">
        <h1 className="reset-heading">Reset Password</h1>
        <div className="inputBoxes">
          <div className="inputBox">
            <InputBox
              isPassword={true}
              icon={passwordIcon}
              placeholder="New Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
            />
          <ErrorMessage message={errors.password} />{" "}
          </div>
          {/* Display password error */}
          <div className="inputBox">
            <InputBox
              isPassword={true}
              icon={passwordIcon}
              placeholder="Confirm New Password"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <ErrorMessage message={errors.confirmPassword} />{" "}
          </div>
          {/* Display confirm password error */}
        </div>

        <div className="buttonDiv">
          <Button forForm={true} title="Reset Password" />
        </div>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
